import React from 'react';
import { Icon as IconInner, IconKind } from '../../client-expo/components/Icon'

export const Icon = (props: { kind: IconKind, style: { size: number, color: string } }) => {
    return (
        <IconInner kind={props.kind} style={{ fontSize: props.style.size, color: props.style.color }} />
    );
};